"use client";
import { Clients } from "@/data/Clients";
import { useSceneContext } from "@/contexts/SceneContext";

export default function ClientLogoFallback() {
  const { webGLAvailable } = useSceneContext();
  if (webGLAvailable) return null;
  return (
    <ul
      data-webgl-fallback="clients"
      className="section-w relative z-20 mx-auto grid grid-cols-2 gap-4 px-5 py-12 md:grid-cols-4 lg:grid-cols-6">
      {Clients.map((client) => (
        <li
          key={client.id}
          className="flex aspect-[2/1] items-center justify-center rounded-lg bg-white p-4">
          {/* eslint-disable-next-line @next/next/no-img-element -- use original logo assets, never rasterize a 3D render */}
          <img
            src={client.img}
            alt={client.name}
            loading="lazy"
            className="max-h-20 w-full object-contain"
            width={240}
            height={120}
          />
        </li>
      ))}
    </ul>
  );
}
